import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

const mapChartData = (rows = []) =>
  rows
    .filter((row) => row.campus !== "OVERALL")
    .map((row) => ({
      campus: row.campus,
      supply: row.supply,
    }));

const RevenueChart = ({ data = [] }) => {
  const chartData = mapChartData(data);

  return (
    <div className="rounded-3xl bg-white p-6 shadow-sm">
      {/* Title */}
      <h2 className="mb-6 text-2xl font-bold text-indigo-950">
        Admissions Supply
      </h2>

      {/* Chart */}
      <div className="h-[340px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={chartData}
            barCategoryGap={25}
            margin={{
              top: 10,
              right: 10,
              left: -10,
              bottom: 45,
            }}
          >
            {/* Grid */}
            <CartesianGrid
              strokeDasharray="0"
              vertical={false}
              stroke="#E5E7EB"
            />

            {/* X Axis */}
            <XAxis
              dataKey="campus"
              tick={{
                fontSize: 12,
                fill: "#94A3B8",
              }}
              interval={0}
              angle={-35}
              textAnchor="end"
              height={70}
              tickLine={false}
              axisLine={false}
            />

            {/* Y Axis */}
            <YAxis
              tick={{
                fontSize: 12,
                fill: "#94A3B8",
              }}
              tickLine={false}
              axisLine={false}
            />

            {/* Tooltip */}
            <Tooltip
              cursor={{ fill: "rgba(0,0,0,0.03)" }}
            />

            {/* Bar */}
            <Bar
              dataKey="supply"
              fill="#168DEB"
              radius={[4, 4, 0, 0]}
              barSize={38}
              isAnimationActive={false}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RevenueChart;
